var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({staticClass:"text-body bg--neutral-100-t mb-2",staticStyle:{"background":"white !important"},attrs:{"filled":"","dense":"","hide-details":!_vm.showDetails},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }